const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

export default class Details {
    constructor($el) {
        this.el = $el;
        this.summary = $el.querySelector('summary');

        this.animating = false;

        this.summary.addEventListener( 'click', (e) => this.onClick(e) );
    }

    onClick(e) {
        e.preventDefault();

        if ( this.animating ) return;

        if ( this.el.open ) {
            this.close();
        } else {
            
            // Close other open dropdowns
            // Jack - This is gross. I couldn't figure out how to reference other Details instances from here. Refactor?
            var openDropdowns = this.el.parentElement.querySelectorAll('.active');
            var openDropdownsArray = [...openDropdowns];
            openDropdownsArray.forEach(openDD => {
                openDD.querySelector('summary').click(); 
            });
            
            this.open();
            
        }
    }

    open() {
        this.animating = true;

        this.el.style.height = `${this.summary.clientHeight}px`;
        this.el.open = true;

        window.requestAnimationFrame( () => {
            this.el.classList.add('active');
            this.el.style.height = `${this.el.scrollHeight}px`;

            setTimeout( () => {
                this.el.style.height = '';
                this.animating = false;
            }, noMotionPreference.matches ? 500 : 1);
        } );
    }

    close() {
        this.animating = true;

        this.el.style.height = `${this.el.offsetHeight}px`;

        window.requestAnimationFrame( () => {
            this.el.style.height = `${this.summary.offsetHeight}px`;
            this.el.classList.remove('active');

            setTimeout( () => {
                this.el.style.height = '';
                this.el.open = false;
                this.animating = false;
            }, noMotionPreference.matches ? 500 : 1);
        } );
    }
}
